import zhMessages from '../locales/zh-CN.json';
import zhCN from 'antd/lib/locale/zh_CN';

const ZhLang = {
  messages: {
    ...zhMessages,
  },
  antLocale: zhCN,
  locale: 'zh-CN',
};
export default ZhLang;
